export default "__VITE_ASSET__NGKrrAm7__"